import React from "react";
const Topvideo=()=>{
    return (
        <div>
        <video width="100%" height="auto" controls loop muted autoPlay  >
        <source src="https://stream.mux.com/ynvXtB01mp4Nor01SVD9TvRTsu00RQ95SPQ/medium.mp4" type="video/mp4"/>
        </video>
        </div>
    )
}
export default Topvideo